export default {
  name: 'InlineCheckbox',
  props: ['field', 'value'],
  data: function data() {
    return {
      model: this.value
    };
  },
  watch: {
    model: function model(value) {
      this.$emit('input', value);
    }
  }
};